// extracted by mini-css-extract-plugin
export default {"Burger":"Burger_Burger__4bzUb","Burger__element":"Burger_Burger__element__C2CUA"};